import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService } from '../../core/services/app-settings.service';
import { Observable } from 'rxjs';
import { CustomField } from '@shared/models/custom-field';

@Injectable({
  providedIn: 'root'
})
export class ProductionOrderCustomFieldsService {

  baseUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.baseUrl = AppSettingsService.appSettings.edaraCoreApi.baseUrl;
    if (this.baseUrl.endsWith('/')) {
      this.baseUrl = this.baseUrl.slice(0, -1);
    }
  }

  getAllCustomFields(): Observable<CustomField[]> {
    return this.httpClient.get<CustomField[]>(`${this.baseUrl}/api/mfg/CustomFields`);
  }

  createCustomField(customField: CustomField): Observable<CustomField> {
    return this.httpClient.post<CustomField>(this.baseUrl + '/api/mfg/CustomFields', customField);
  }

  updateCustomField(customField: CustomField): Observable<boolean> {
    return this.httpClient.put<boolean>(this.baseUrl + '/api/mfg/CustomFields/' + customField.id, customField);
  }

  deleteCustomField(customFieldId: string): Observable<boolean> {
    return this.httpClient.delete<boolean>(this.baseUrl + '/api/mfg/CustomFields/' + customFieldId);
  }

}
